module.exports = __webpack_public_path__ + "static/media/zuima.4f7ef2af.png";